import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";
import { useMemo } from "react";
import { Item } from "devextreme-react/toolbar";
import DataGrid, {
  Column,
  Editing,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";

import {
  deleteSubcategory,
  editSubcategory,
  fetchSubcategories,
} from "../../../api/settingsApi";

import { useAuth } from "../../../contexts/auth";
import { SubText } from "../../../components/typographyText/TypographyText";
import { Button } from "devextreme-react";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import "./ProjectsTab.scss";
import { confirm } from "devextreme/ui/dialog";

const ProjectsTab = forwardRef((reloadProjects) => {
  const { user } = useAuth();

  const [projects, setProjects] = useState([]);
  const [activeRow, setActiveRow] = useState(null);



  const reversedProjects = useMemo(() => {
    return projects ? [...projects].reverse() : [];
  }, [projects]);

  useEffect(() => {
    fetchProjects();
    // fetchCategories();
  }, [reloadProjects]);

  const fetchProjects = async () => {
    try {
      const response = await fetchSubcategories();

      const data = response?.data || [];

      setProjects(data);
    } catch (error) {
      console.error("Fetch Category Error:", error);
      ToastDisplayer("error", "Failed to load category");
    }
  };

  const handleEditProject = async (updatedData) => {
    try {
      const payload = {
        ticketsubcatname: updatedData.ticketsubcatname,
        description: updatedData.description,
        access_start: updatedData.access_start,
        access_deadline: updatedData.access_deadline,

      };

      await editSubcategory(updatedData.transid, payload);

      ToastDisplayer("success", "Category updated successfully");
    } catch (error) {

      ToastDisplayer("error", error.message || "Failed to update Category");

      throw error;
    }
  };

  const handleDeleteProject = async (e) => {
    e.cancel = true; // STOP default delete

    try {
      const result = await confirm(
        "Are you sure you want to delete this category?"
      );

      if (!result) return;

      await deleteSubcategory(e.data.transid);

      ToastDisplayer("success", "Category deleted successfully");

      fetchProjects(); // refresh grid
    } catch (error) {
      ToastDisplayer(
        "error",
        error.message || "Failed to delete project"
      );
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };
  //   const fetchCategories = async () => {
  //     const response = await getCategoryData();

  //     setCategories(
  //       response.data.map((cat) => ({
  //         value: cat.transid,
  //         text: cat.ticketcategoryname,
  //       }))
  //     );
  //   };

  return (
    <>
      <DataGrid
        className="add-category-section"
        style={{ height: "calc(100vh - 280px)" }}
        dataSource={reversedProjects}
        columnAutoWidth={true}
        keyExpr="transid"
        onRowUpdating={async (e) => {
          try {
            const updatedData = {
              ...e.oldData,
              ...e.newData,
            };

            const start = updatedData.access_start
              ? new Date(updatedData.access_start)
              : null;

            const end = updatedData.access_deadline
              ? new Date(updatedData.access_deadline)
              : null;

            const now = new Date();

            //  Start cannot be future
            // if (start && start > now) {
            //   ToastDisplayer("error", "Start time cannot be greater than current time");
            //   e.cancel = true;
            //   return;
            // }

            //  End required
            if (start && !end) {
              ToastDisplayer("error", "End time is required");
              e.cancel = true;
              return;
            }

            //  End > Start
            if (start && end && end <= start) {
              ToastDisplayer("error", "End time must be greater than start time");
              e.cancel = true;
              return;
            }

            await handleEditProject(updatedData);

          } catch (error) {
            e.cancel = true;
            ToastDisplayer("error", error.message || "Failed to update Category");
          }
        }}
        onRowRemoving={handleDeleteProject}
      >
        <Editing
          mode="row"
          allowUpdating={true}
          useIcons={true}
          allowDeleting={true}
          confirmDelete={false}
        />
        <Toolbar>
          <Item location="before" >
            <div style={{ fontWeight: "600", fontSize: "18px" }}>
              <SubText text={`Total ${projects.length} Categories`} />
            </div>

          </Item>
          <Item name="searchPanel" />
        </Toolbar>
        <SearchPanel visible={true} width={window.innerWidth <= 480 ? 160 : 200} placeholder="Search" />
        <Pager
          visible={true}
        // allowedPageSizes={[10, 20, 30]}
        // showPageSizeSelector={true}
        />
        <Paging defaultPageSize={10} />
        <Scrolling mode="virtual" />

        <Column
          width={window.innerWidth <= 480 ? 190 : 400}
          dataField="ticketsubcatname"
          caption="CATEGORY"
          allowEditing={true}
        />

        <Column
          width={250}
          dataField="ticketcategoryname"
          caption="PROJECT"
          allowEditing={false}
          hidingPriority={2}
        />
        <Column
          dataField="description"
          caption="DESCRIPTION"
          allowEditing={true}
          cellRender={({ value }) => <span>{value ? value : "-"}</span>}
          hidingPriority={1}
        />
        <Column
          dataField="access_start"
          caption="Start Time"
          dataType="datetime"
          allowEditing={true}
          editorType="dxDateBox"
          hidingPriority={4}
          editorOptions={{
            type: "datetime",
            displayFormat: "dd-MM-yyyy HH:mm",
          }}
          cellRender={({ value }) => <span>{formatDateTime(value)}</span>}
        />

        <Column
          dataField="access_deadline"
          caption="End Time"
          dataType="datetime"
          allowEditing={true}
          editorType="dxDateBox"
          hidingPriority={3}
          editorOptions={{
            type: "datetime",
            displayFormat: "dd-MM-yyyy HH:mm",
          }}
          cellRender={({ value }) => <span>{formatDateTime(value)}</span>}
        />
        {/* <Column type="buttons">
          <Button name="edit" />
          <Button name="save" />
          <Button name="cancel" />

          <Button
            icon="trash"
            hint="Delete"
            onClick={handleDeleteProject}
          />
        </Column> */}
      </DataGrid>
    </>
  );
});

export default ProjectsTab;
